import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './Button/index.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';
var _excluded = ["className", "disabled", "fixedSize", "icon", "imgUrl", "rounded"];

var SSOButton = function SSOButton(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      fixedSize = _ref.fixedSize,
      icon = _ref.icon,
      imgUrl = _ref.imgUrl,
      rounded = _ref.rounded,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var buttonClass = _formatClassName([className, 'btn-sso', 'btn-block', 'large', {
    'fixed-size': fixedSize,
    'with-icon': !!icon,
    'with-image-icon': !!imgUrl,
    rounded: rounded
  }]);

  var buttonStyle = imgUrl && !disabled ? {
    backgroundImage: "url(".concat(imgUrl, ")")
  } : null;
  return /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    style: "secondary",
    className: buttonClass,
    cssStyle: buttonStyle,
    icon: imgUrl ? null : icon,
    disabled: disabled,
    renderAsLegacy: true
  }));
};

SSOButton.displayName = "SSOButton";
SSOButton.propTypes = _objectSpread2(_objectSpread2({}, Button.propTypes), {}, {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fixedSize: PropTypes.bool,
  icon: PropTypes.string,
  imgUrl: PropTypes.string,
  rounded: PropTypes.bool
});
SSOButton.defaultProps = {
  fixedSize: false,
  rounded: false,
  disabled: false
};
export { SSOButton };